/**
 * Compare function list
 */

const messageComponent = document.querySelector('tpt-simple-message');

let maxItemCompare = window.compare.compare_max_item;

function openCompareBar() {
	document.querySelector('tpt-compare-component').classList.add('active');
}

function closeCompareBar() {
	document.querySelector('tpt-compare-component').classList.remove('active');
}

function listCompare() {
	const listCompareItem = document.querySelector('.tpt-compare__bar .tpt-compare__list');
	const compares = JSON.parse(sessionStorage.getItem('compare_products')) || [];
	const compareEmpty = maxItemCompare - compares.length;
	let compareItemHtml = '';

	compares.forEach((item, index) => {
		let productIndex = index + 1;
		if (productIndex == maxItemCompare) {
			var classMaxItem = 'tpt-compare__list-product--max';
		} else {
			var classMaxItem = '';
		}
		compareItemHtml =
			compareItemHtml +
			`<div class="tpt-compare__list-item tpt-compare__list-product tpt-compare__list-product--${productIndex} ${classMaxItem}">
				<img src="${item.thumb}" alt="${item.title}" width="200" height="200">

				<tpt-compare-remove-item class="tpt-compare__list-item--remove" data-handle="${item.handle}">
					<svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M1.59392 0.815912C1.44719 0.670738 1.20991 0.670738 1.06318 0.815912C0.916441 0.961087 0.918002 1.19992 1.06318 1.34666L3.91985 4.20333L1.06318 7.06C0.916441 7.20673 0.916441 7.44401 1.06318 7.58918C1.20991 7.73436 1.44719 7.73592 1.59236 7.58918L4.44903 4.73251L7.30726 7.59074C7.454 7.73748 7.69127 7.73748 7.83645 7.59074C7.98162 7.44401 7.98318 7.20673 7.83645 7.06156L4.97978 4.20489L7.83801 1.34666C7.98475 1.19992 7.98475 0.962648 7.83801 0.817473C7.69127 0.672299 7.454 0.670737 7.30882 0.817473L4.45215 3.67414L1.59392 0.815912Z" fill="black"/>
					</svg>
				</tpt-compare-remove-item>
			</div>`;
	});

	if (compareEmpty) {
		for (let i = 0; i < compareEmpty; i++) {
			compareItemHtml =
				compareItemHtml +
				`<div class="tpt-compare__list-item tpt-compare__list-add">
					<tpt-compare-add-more class="tpt-compare__add-more" arial-label="Add Item">
						<svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect x="12.9453" y="0.828125" width="1.57717" height="26.0233" fill="#919191"/>
						<rect x="12.9453" y="0.828125" width="1.57717" height="26.0233" fill="#919191"/>
						<rect x="12.9453" y="0.828125" width="1.57717" height="26.0233" fill="#919191"/>
						<rect x="26.3516" y="13.4453" width="1.57717" height="26.0233" transform="rotate(90 26.3516 13.4453)" fill="#919191"/>
						<rect x="26.3516" y="13.4453" width="1.57717" height="26.0233" transform="rotate(90 26.3516 13.4453)" fill="#919191"/>
						<rect x="26.3516" y="13.4453" width="1.57717" height="26.0233" transform="rotate(90 26.3516 13.4453)" fill="#919191"/>
						</svg>
					</tpt-compare-add-more>
				</div>`;
		}
	}

	if (compareItemHtml) {
		listCompareItem.innerHTML = compareItemHtml;
	}

	countCompareItem();
}

function updateCompareButton() {
	document.querySelectorAll('tpt-compare').forEach((compareButton) => {
		compareButton.syncActiveState();
	});
}

listCompare();

/**
 * Compare trigger
 */
if (!customElements.get('tpt-compare')) {
	customElements.define(
		'tpt-compare',
		class TptCompare extends HTMLElement {
			constructor() {
				super();
				this.addEventListener('click', this.addRemoveCompare.bind(this));
			}

			connectedCallback() {
				this.syncActiveState();
			}

			addRemoveCompare() {
				const handle = this.dataset.productHandle;
				const productId = this.dataset.productId;
				const category = this.dataset.productCategory;
				const url = this.dataset.productUrl;
				const title = this.dataset.productTitle;
				const thumb = this.dataset.productThumbImageUrl;

				if (!handle || !category) return;

				const storageKey = 'compare_products';
				let compares = JSON.parse(sessionStorage.getItem(storageKey)) || [];

				// check category
				if (compares.length > 0 && compares.some((item) => item.category !== category)) {
					messageComponent.message('error', `${window.compare.mess_diff_category}`);
					messageComponent.show();

					openCompareBar();
					return;
				}

				const existingIndex = compares.findIndex((item) => item.handle === handle);

				if (existingIndex !== -1) {
					// remove if exits
					compares.splice(existingIndex, 1);
				} else {
					// max 3 items
					if (compares.length >= maxItemCompare) {
						messageComponent.message('error', `${window.compare.mess_max_item}`);
						messageComponent.show();

						openCompareBar();

						return;
					}

					compares.push({
						handle,
						category,
						url,
						title,
						thumb,
					});

					sessionStorage.setItem('lastCompareAdded', productId);

					//listCompare();
				}

				sessionStorage.setItem(storageKey, JSON.stringify(compares));

				this.syncActiveState();
				listCompare();
				openCompareBar();
			}

			syncActiveState() {
				const handle = this.dataset.productHandle;
				const compares = JSON.parse(sessionStorage.getItem('compare_products')) || [];

				if (compares.some((item) => item.handle === handle)) {
					this.classList.add('active');
				} else {
					this.classList.remove('active');
				}
			}
		}
	);
}

/**
 * Compare remove item
 */

if (!customElements.get('tpt-compare-remove-item')) {
	customElements.define(
		'tpt-compare-remove-item',
		class TptCompareRemoveItem extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.removeItemCompare.bind(this));
			}

			removeItemCompare() {
				let compares = JSON.parse(sessionStorage.getItem('compare_products')) || [];
				const handle = this.dataset.handle;
				const existingIndex = compares.findIndex((item) => item.handle === handle);

				if (existingIndex !== -1) {
					compares.splice(existingIndex, 1);
					sessionStorage.setItem('compare_products', JSON.stringify(compares));

					listCompare();
					updateCompareButton();
				}
			}
		}
	);
}

/**
 * Compare show less
 */

if (!customElements.get('tpt-compare-show-less')) {
	customElements.define(
		'tpt-compare-show-less',
		class TptCompareShowLess extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.compareShowLess.bind(this));
			}

			compareShowLess() {
				closeCompareBar();

				listCompare();
			}
		}
	);
}

/**
 * Compare clear all
 */

if (!customElements.get('tpt-compare-clear-all')) {
	customElements.define(
		'tpt-compare-clear-all',
		class TptCompareClearAll extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.compareClearAll.bind(this));
			}

			compareClearAll() {
				sessionStorage.setItem('compare_products', JSON.stringify([]));

				updateCompareButton();
				listCompare();
			}
		}
	);
}

/**
 * Compare count
 */

function countCompareItem() {
	const countElement = document.querySelectorAll('.tpt-compare__count');
	let compares = JSON.parse(sessionStorage.getItem('compare_products')) || [];
	const totalItemCompare = compares.length;

	countElement.forEach((item) => {
		item.innerHTML = totalItemCompare;
	});

	if (totalItemCompare) {
		document.querySelector('tpt-compare-count').classList.add('show');
	} else {
		document.querySelector('tpt-compare-count').classList.remove('show');
	}
}

// countCompareItem();

if (!customElements.get('tpt-compare-count')) {
	customElements.define(
		'tpt-compare-count',
		class TptCompareCount extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.showComparebar.bind(this));
			}

			showComparebar() {
				document.querySelector('tpt-compare-component').classList.add('active');
			}
		}
	);
}

/**
 * Compare button modal
 */

if (!customElements.get('tpt-compare-modal-trigger')) {
	customElements.define(
		'tpt-compare-modal-trigger',
		class TptCompareButtonModal extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.showCompareModal.bind(this));
			}

			showCompareModal() {
				document.getElementById('tpt-modal-compare').classList.add('show');
				document.getElementsByTagName('html')[0].classList.add('open-modal');

				renderCompareListModal();
			}
		}
	);
}

async function renderCompareListModal() {
	let compares = JSON.parse(sessionStorage.getItem('compare_products')) || [];
	let row = 0;
	const tableCompareBody = document.querySelector('#tpt-table-compare tbody');

	tableCompareBody.innerHTML = '';
	document.body.classList.remove('compare-loaded');

	for (const compareItem of compares) {
		const fetchUrl = `${window.compare.rootUrl}/products/${compareItem.handle}?section_id=tpt-compare-item-detail`;

		try {
			const response = await fetch(fetchUrl);
			const responseText = await response.text();
			const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
			const sectionElement = responseHTML.querySelector('.shopify-section');
			const rowData = sectionElement.querySelectorAll('.shopify-section .tpt-compare-append');
			const rowCount = rowData.length;

			if (row === 0) {
				row = rowCount;
				for (let i = 0; i < rowCount; i++) {
					tableCompareBody.insertAdjacentHTML('beforeend', '<tr></tr>');
				}
			}

			for (let i = 0; i < row; i++) {
				const rows = tableCompareBody.querySelectorAll('tr');
				if (rowData[i]) {
					rows[i].insertAdjacentHTML('beforeend', `<td>${rowData[i].innerHTML}</td>`);
				} else {
					rows[i].insertAdjacentHTML('beforeend', '<td></td>');
				}
			}
		} catch (error) {
			console.error(`Error fetching ${fetchUrl}:`, error);
		}
	}

	document.body.classList.add('compare-loaded');
}

/**
 * Compare button modal
 */

if (!customElements.get('tpt-compare-diff')) {
	customElements.define(
		'tpt-compare-diff',
		class TptCompareDiff extends HTMLElement {
			constructor() {
				super();
			}

			connectedCallback() {
				this.addEventListener('click', this.showDiff.bind(this));
			}

			showDiff() {
				const table = document.querySelector('#tpt-table-compare');
				const rows = table.querySelectorAll('tbody tr');
				const isActive = this.classList.toggle('active'); // toggle trạng thái

				rows.forEach((row) => {
					const fields = row.querySelectorAll('.tpt-compare-field');

					// Nếu hàng này có field để so sánh
					if (fields.length > 0) {
						// Lấy text của tất cả các cột
						const values = Array.from(fields).map((f) => f.querySelector('.tpt-compare-value')?.textContent.trim() || '');

						// Kiểm tra tất cả giá trị có giống nhau không
						const allSame = values.every((val) => val === values[0]);

						// Nếu toggle bật và tất cả giống nhau → ẩn hàng
						if (isActive && allSame) {
							row.style.display = 'none';
						} else {
							row.style.display = '';
						}
					}
				});
			}
		}
	);
}

/**
 * Add more compare item
 */

function addMoreCompare() {
	const compareSuggest = document.querySelector('#tpt-modal-compare-suggest');
	const viewedWrapper = document.querySelector('.tpt-compare__recently-list');

	const lastAddedCompareItem = sessionStorage.getItem('lastCompareAdded');

	compareSuggest.classList.add('loading');
	document.body.classList.remove('compare-loaded');
	compareSuggest.classList.add('show');
	document.getElementsByTagName('html')[0].classList.add('open-modal');

	viewedWrapper.innerHTML = '';

	let viewedArr = JSON.parse(sessionStorage.getItem('viewedProduct')) || [];

	if (viewedArr.length) {
		viewedWrapper.classList.remove('tpt-no-recently-viewed');

		viewedArr.forEach((item) => {
			const productUrl = `${window.compare.rootUrl}/products/${item.product_handle}?section_id=tpt-compare-viewed-product-item`;

			const productContainer = `<div class="tpt-compare__viewed-item" data-product-handle="${productUrl}"></div>`;

			viewedWrapper.insertAdjacentHTML('beforeend', productContainer);
		});

		setTimeout(() => {
			const productElement = viewedWrapper.querySelectorAll('[data-product-handle]');

			productElement.forEach((product) => {
				const productUrl = product.getAttribute('data-product-handle');

				fetch(productUrl)
					.then((response) => response.text())
					.then((responseText) => {
						const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
						const dataHtml = responseHTML.querySelector('.shopify-section').innerHTML;

						product.innerHTML = dataHtml;
					})
					.finally(() => {
						compareSuggest.classList.remove('loading');
					});
			});
		}, 200);
	} else {
		viewedWrapper.classList.add('tpt-no-recently-viewed');
	}

	/**
	 * Render recommended products
	 */

	if (lastAddedCompareItem && viewedArr.length <= 3) {
		const recommendedUrl = `${window.compare.rootUrl}/recommendations/products?section_id=tpt-compare-recommended&product_id=${lastAddedCompareItem}&limit=6&intent=related`;
		const recommendedElement = document.querySelector('.tpt-compare__recommended');

		fetch(recommendedUrl)
			.then((response) => response.text())
			.then((responseText) => {
				const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
				const dataHtml = responseHTML.querySelector('.shopify-section').innerHTML;

				recommendedElement.innerHTML = dataHtml;
			})
			.finally(() => {
				compareSuggest.classList.remove('loading');
			});
	}
}

if (!customElements.get('tpt-compare-add-more')) {
	customElements.define(
		'tpt-compare-add-more',
		class TptCompareAddMore extends HTMLElement {
			constructor() {
				super();

				this.compareSuggest = document.querySelector('#tpt-modal-compare-suggest');
				this.viewedWrapper = document.querySelector('.tpt-compare__recently-list');
			}

			connectedCallback() {
				this.addEventListener('click', this.addMoreCompareItem.bind(this));
			}

			addMoreCompareItem() {
				addMoreCompare();
			}
		}
	);
}

if (!customElements.get('tpt-compare-add-more-modal')) {
	customElements.define(
		'tpt-compare-add-more-modal',
		class TptCompareAddMoreModal extends HTMLElement {
			constructor() {
				super();

				this.compareSuggest = document.querySelector('#tpt-modal-compare-suggest');
				this.viewedWrapper = document.querySelector('.tpt-compare__recently-list');
			}

			connectedCallback() {
				this.addEventListener('click', this.addMoreCompareItem.bind(this));
			}

			addMoreCompareItem() {
				document.querySelector('#tpt-modal-compare').closeModal();
				document.querySelector('tpt-compare-add-more').addMoreCompareItem();
			}
		}
	);
}

/**
 * Viewed product
 */

function setViewedProduct(currentProductObject) {
	if (currentProductObject) {
		if (sessionStorage.getItem('viewedProduct')) {
			const currentProductHandle = currentProductObject.product_handle;
			const limit = window.compare.viewed_max_item;
			const newViewedArr = [];
			let viewedFlag = false;

			const viewedArr = JSON.parse(sessionStorage.getItem('viewedProduct'));

			for (let i = 0; i < viewedArr.length; i++) {
				if (viewedArr[i].product_handle == currentProductHandle) {
					viewedFlag = true;
					return;
				}
			}

			if (!viewedFlag) {
				viewedArr.unshift(currentProductObject);

				for (let i = 0; i < viewedArr.length; i++) {
					if (i < limit) {
						newViewedArr.push(viewedArr[i]);
					}
				}

				sessionStorage.setItem('viewedProduct', JSON.stringify(newViewedArr));
			}
		} else {
			const viewedArr = [];

			viewedArr.push(currentProductObject);
			sessionStorage.setItem('viewedProduct', JSON.stringify(viewedArr));
		}
	}
}

setViewedProduct(window.current_product);

/**
 * Simple messsage component
 */

if (!customElements.get('tpt-simple-message')) {
	customElements.define(
		'tpt-simple-message',
		class TptSimpleMessage extends HTMLElement {
			constructor() {
				super();
			}

			connectedCallback() {
				const buttonClose = this.querySelector('.tpt-simple-message__button');
				this.textHtml = this.querySelector('.tpt-simple-message__text');
				buttonClose.addEventListener('click', this.close.bind(this));
				this.timeOut = '';
			}

			message(type, message) {
				this.classList.remove('tpt-simple-message__error', 'tpt-simple-message__success', 'tpt-simple-message__warning');
				this.textHtml.innerHTML = message;
				this.classList.add('tpt-simple-message__' + type);
			}

			show() {
				this.classList.add('active');

				const messageElement = this;

				this.timeOut = setTimeout(() => {
					messageElement.close();
				}, 4000);
			}

			close() {
				this.classList.remove('active');
				clearTimeout(this.timeOut);
			}
		}
	);
}
